import { shopSession } from "../../services/api";

/**
 * Local storage helpers for the register.
 *
 * The counter device keeps held tickets, the offline sale queue and the
 * "most rung up" counters locally so the register stays usable while the
 * shop's connection is down.
 *
 * Each shop keeps its own: an owner's phone can be the till of two shops, and a
 * sale queued in one must never be replayed into the other. Keys carry the shop
 * this install is on (`pos_outbox:<shop id>`). What a device stored before shop
 * switching existed was written while it only ever knew one shop, so it is moved
 * under that shop's key the first time it is read.
 */
const scoped = (key) => {
  const shopId = shopSession.currentId();
  return shopId ? `${key}:${shopId}` : key;
};

const read = (key, fallback) => {
  try {
    const own = scoped(key);
    let raw = window.localStorage.getItem(own);

    if (raw === null && own !== key) {
      const legacy = window.localStorage.getItem(key);
      if (legacy !== null) {
        window.localStorage.setItem(own, legacy);
        window.localStorage.removeItem(key);
        raw = legacy;
      }
    }

    return raw ? JSON.parse(raw) : fallback;
  } catch (error) {
    return fallback;
  }
};

const write = (key, value) => {
  try {
    window.localStorage.setItem(scoped(key), JSON.stringify(value));
  } catch (error) {
    // Storage full or unavailable (private browsing): the register keeps
    // working, it just forgets between reloads.
  }
};

export const POS_STORAGE_KEYS = {
  heldTickets: "pos_held_tickets",
  outbox: "pos_outbox",
  frequency: "pos_product_frequency",
};

export const readStored = read;
export const writeStored = write;

/** Sales rung up here and not yet sent: a shop is not switched while there are any. */
export const unsentSales = () => read(POS_STORAGE_KEYS.outbox, []).length;
